import { Common } from './common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async verify(
    captchaToken: string,
  ): Promise<{ status: number; message?: string | undefined }> {
    const url = this.common.constructPath('/patient-previsit/captcha/verify');
    return this.common.postJSON(url, { captchaToken }, 'POST', undefined, true);
  }
}
